import { render, staticRenderFns } from "./MarketplaceListingsDeactive.vue?vue&type=template&id=7babefbe"
import script from "./MarketplaceListingsDeactive.vue?vue&type=script&lang=js"
export * from "./MarketplaceListingsDeactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports